const OIDC_STORAGE_PREFIX = "onlive_oidc_"
export const OIDC_CALLBACK_PAYLOAD_KEY = "onlive_oidc_callback_payload"

const base64UrlEncode = (value) => {
  return btoa(String.fromCharCode(...Array.from(value)))
    .replace(/=/g, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
}

const randomString = (byteLength = 32) => {
  const array = new window.Uint8Array(byteLength)
  crypto.getRandomValues(array)
  return base64UrlEncode(array)
}

const generateCodeVerifier = () => {
  const array = new window.Uint8Array(32)
  crypto.getRandomValues(array)
  return base64UrlEncode(array)
}

const generateCodeChallenge = async (verifier) => {
  try {
    const encoder = new TextEncoder()
    const data = encoder.encode(verifier)
    const hash = await crypto.subtle.digest("SHA-256", data)
    return base64UrlEncode(new window.Uint8Array(hash))
  } catch {
    return btoa(verifier).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_")
  }
}

const getOidcBaseUrl = () => {
  return (process.env.NEXT_PUBLIC_OIDC || `${process.env.NEXT_PUBLIC_LOGIN_DOMAIN}/api-core/v2/oidc-service`).replace(
    /\/$/,
    ""
  )
}

export const getOidcTransaction = (state) => {
  if (typeof window === "undefined" || !state) return null

  const item =
    localStorage.getItem(`${OIDC_STORAGE_PREFIX}${state}`) || sessionStorage.getItem(`${OIDC_STORAGE_PREFIX}${state}`)
  if (!item) return null

  try {
    return JSON.parse(item)
  } catch {
    return null
  }
}

export const clearOidcTransaction = (state) => {
  if (typeof window === "undefined" || !state) return

  localStorage.removeItem(`${OIDC_STORAGE_PREFIX}${state}`)
  sessionStorage.removeItem(`${OIDC_STORAGE_PREFIX}${state}`)
}

export const handleLogin = async ({ redirectUrl, mode = "popup" }) => {
  if (typeof window === "undefined") return

  const clientId = process.env.NEXT_PUBLIC_CLIENT_ID
  const hostDomain = process.env.NEXT_PUBLIC_DOMAIN
  const urlCallBack = `${hostDomain}${redirectUrl}`
  const state = randomString()
  const nonce = randomString()

  const createTransaction = (loginMode) =>
    JSON.stringify({
      mode: loginMode,
      createdAt: Date.now()
    })

  const transaction = createTransaction(mode)

  const storeTransaction = (value) => {
    localStorage.setItem(`${OIDC_STORAGE_PREFIX}${state}`, value)
    sessionStorage.setItem(`${OIDC_STORAGE_PREFIX}${state}`, value)
  }

  // Store by state so multiple popup attempts do not overwrite one another.
  storeTransaction(transaction)

  const searchParams = new URLSearchParams({
    // protocol: "oauth2",
    response_type: "id_token",
    client_id: clientId,
    redirect_uri: urlCallBack,
    scope: "openid phone api_profile_get",
    state,
    nonce
  })

  const href = `${getOidcBaseUrl()}/oauth2/auth?${searchParams.toString()}`

  if (mode === "redirect") {
    window.location.href = href
    return
  }

  const loginWindow = window.open(
    href,
    "LoginWindow",
    "width=500,height=650,top=100,left=100,menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes"
  )

  if (loginWindow) {
    loginWindow.focus()
  } else {
    storeTransaction(createTransaction("redirect"))
    window.location.href = href
  }
}
